import React from 'react';
import {normalizeTrack} from './listeningHistory';

function getTopPlayedTracks(data, topN = 5) {
    const trackMap = {};

    data.forEach((rawTrack) => {
        const { artistName, trackName, msPlayed } = normalizeTrack(rawTrack);
        const key = `${artistName} - ${trackName}`;

        if (!trackMap[key]) {
            trackMap[key] = { artistName, trackName, playCount: 0, totalMsPlayed: 0 };
        }

        trackMap[key].playCount += 1;
        trackMap[key].totalMsPlayed += msPlayed;
    });

    return Object.values(trackMap)
        .sort((a, b) => b.playCount - a.playCount)
        .slice(0, topN);
}

const TopTracks = ({ data, amount }) => {
    const topTracks = getTopPlayedTracks(data, amount);
    const maxPlayCount = Math.max(...topTracks.map(track => track.playCount), 1);

    return (
        <ol className="top-track-list">
            {topTracks.map((track, index) => (
                <li key={`${track.artistName}-${track.trackName}-${index}`}>
                    <div className="top-track-title">
                        <strong>{track.trackName}</strong>
                        <span>{track.artistName}</span>
                    </div>
                    <span className="top-track-count">{track.playCount}×</span>
                    <div className="top-track-chart" aria-label={`${track.playCount} plays`}>
                        <span style={{ width: `${(track.playCount / maxPlayCount) * 100}%` }} />
                    </div>
                    <span className="top-track-time">{(track.totalMsPlayed / 1000 / 60).toFixed(1)} min listened</span>
                </li>
            ))}
        </ol>
    );
};

export { TopTracks };
